"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var qs_1 = __importDefault(require("qs"));
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (orgId, page) {
        var params = qs_1.default.stringify({
            organization_id: orgId,
            filter: {
                organization_id: orgId,
                page: page
            }
        });
        return api_base_1.default.get("active_tours?" + params).then(function (response) { return response.data.data[0]; });
    },
    complete: function (reference) {
        return api_base_1.default.post("tours/" + reference + "/completions");
    }
};
//# sourceMappingURL=tours_api.js.map